<template>
  <el-table :data="tableData.records" style="width: 100%">
    <el-table
      :data="tableData"
      >
      <el-table-column
        prop="date"
        label="省份">
      </el-table-column>
      <el-table-column
        prop="name"
        label="城市">
      </el-table-column>
    </el-table>
  </el-table>
</template>
  
  <script>
import TableCompnent from "@/components/table/TablesComponents";
import FrontErrorLogReportApi from "@/api/FrontErrorLogReportApi";
import "codemirror/theme/ambiance.css";
export default {
  name: "FrontMonitor",
  props: {
    msg: String,
  },
  components: {
    TableCompnent,
  },
  data() {
    return {
      tableData: {
        records: [],
      },
      search: {
        projectName: "",
      },
      page: {},
      
    };
  },
  created() {
    this.doSearch({ pageSize: 1, pageNum: 20 });
  },
  methods: {
    reset() {
      this.search = {};
    },
    doSearch(params) {
      
    },
    saveMenu() {},
    queryById(id) {},
    deleteById(id) {
      
    },
    batchDelete(params) {},
  },
};
</script>